import type { Options, Theme } from "@mui/material";
import { useMediaQuery as muiUseMediaQuery } from "@mui/material";

export function useMediaQuery(
  queryInput: string | ((theme: Theme) => string),
  options?: Options
) {
  return muiUseMediaQuery(queryInput, options);
}
